import Service from './Service';

export default class ExternalStatusMapService extends Service{
    constructor() {
        super();
        this.baseURL = 'externalStatusMap';
    }

}